// extracted by mini-css-extract-plugin
module.exports = {"white":"_3H-wJ","greyLight":"_1sYiV","label":"_30L6x"};